<template>
    <v-container fluid>
        <v-row class="d-flex justify-left">
            <v-col cols="12">
                <div class="d-flex justify-center">
                    <v-subheader class="headline font-weight-bold ">Wow Kit</v-subheader>
                </div>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="modules.WOW_KIT_BOM_CONFIGURATION">
                <router-link :to="{ name: 'wowKitBomConfiguration' }">
                    <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-tag-heart-outline" color="pink"
                        cardTitle="WOW Kit BOM Configuration"> </clickable-card>
                </router-link>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="modules.WOW_KIT_ORDERS">
                <router-link :to="{ name: 'wowKitOrdering' }">
                    <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-account" color="orange"
                        cardTitle="WOW Kit Ordering"> </clickable-card>
                </router-link>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import Utils from '@/utils'
import ClickableCard from '@/components/template/ClickableCard'

export default {
  name: 'wowKitDashboard',
  components: { ClickableCard },
  data () {
    return {
      modules: {
        WOW_KIT_ORDERS: this.checkModuleAccess('WOW_KIT_ORDER'),
        WOW_KIT_BOM_CONFIGURATION: this.checkModuleAccess('WOW_KIT_BOM_CONFIGURATION')
      }
    }
  },
  created () {
    // console.log(this.checkModuleAccess('WOW_KIT_BOM_CONFIGURATION'))
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  }
}
</script>
